import React from "react";
import { Button } from "react-bootstrap";

const DownloadPDF = ({ pdfUrl, title }) => {
  const handleDownload = () => {
    window.open(pdfUrl, "_blank");
  };

  return (
    <Button className="btn btn-primary text-center" onClick={handleDownload}>
      {title}
    </Button>
  );
};

export default DownloadPDF;
